// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"164":"room-board.page","569":"room-qr.page","831":"wish.page"}[chunkId] || chunkId) + "." + {"14":"b69a7555","164":"caf39758","467":"997c7895","569":"43a1e0e3","786":"91349bbf","831":"099589f3","883":"ed566184"}[chunkId] + ".chunk.js";
};